import { ReactNode } from 'react'
import { Spoiler } from 'summon-ui/mantine'

export const ReadMore = ({ children }: { children: ReactNode }) => {
  return (
    <Spoiler
      className='[&>button]:font-bold [&>button]:text-sm'
      maxHeight={75}
      showLabel='Show More'
      hideLabel='Show Less'
    >
      {children}
    </Spoiler>
  )
}
